import { render, staticRenderFns } from "./PjtkChart.vue?vue&type=template&id=ddde2df0&scoped=true"
import script from "./PjtkChart.vue?vue&type=script&lang=js"
export * from "./PjtkChart.vue?vue&type=script&lang=js"
import style0 from "./PjtkChart.vue?vue&type=style&index=0&id=ddde2df0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddde2df0",
  null
  
)

export default component.exports